import axiosInstance from './AxiosInstance';

class LookupsService {
  constructor() {
    this.endpoint = "/api/lookups"
  }


  async statuses() {
    try {
      let response = await axiosInstance.get(`${this.endpoint}/services/status`);
      return (response.data)
    } catch (error) {
      console.log("look up", error)
      return {}
    }
  }

  async getAll() {
    try {
      const response = await axiosInstance.get(this.endpoint);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getByName(name) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/name/?name=${name}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getDocumentTypes(params) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/document-types`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

}

const lookupsService = new LookupsService();

export { lookupsService };